exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-selected-box {\n  background-color: aliceblue;\n  margin-top: 10px;\n  border-radius: 4px;\n  border: 1px dashed #ccc;\n  padding: 2px;\n  font-size: 12px;\n  max-width: 170px;\n  margin-left: 2px;\n  cursor: pointer; }\n\n.img-mc {\n  max-height: 450px;\n  min-height: 450px;\n  border: 1px solid #ccc;\n  margin: 4px;\n  padding: 2px;\n  text-align: center; }\n  .img-mc img {\n    height: 442px; }\n\n.filter {\n  margin-top: 16px;\n  margin-left: auto;\n  font-size: 14px;\n  text-align: center;\n  padding-top: 10px;\n  height: 40px;\n  width: 80px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: aliceblue;\n  font-weight: 900; }\n\n.export-btn {\n  padding-top: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/plan-sale/plan-sale.scss
// module id = ../../../../../src/app/pages/plan-sale/plan-sale.scss
// module chunks = 39